import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { AlertTriangle } from 'lucide-react';

interface PropertyErrorBoundaryProps {
  children: React.ReactNode;
  propertyName?: string;
  propertyKey?: string;
}

export const PropertyErrorBoundary: React.FC<PropertyErrorBoundaryProps> = ({ 
  children, 
  propertyName,
  propertyKey 
}) => {
  const displayName = propertyName || propertyKey;
  return (
    <ErrorBoundary
      level="component"
      onError={(error, errorInfo) => {
        // Property-specific error handling
        // Already logged by ErrorBoundary
      }}
      fallback={
        <div className="p-3 border border-destructive/50 rounded-md bg-destructive/5">
          <div className="flex items-center gap-2 text-sm text-destructive">
            <AlertTriangle className="h-4 w-4 flex-shrink-0" />
            <span className="font-medium">
              {displayName ? `Error in ${displayName}` : 'Property Error'}
            </span>
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            This property field failed to render. Try refreshing the page.
          </p>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
